import HighchartsReact from 'highcharts-react-official';
import Highcharts from 'highcharts';
import React, { forwardRef, useImperativeHandle, useRef, useState } from 'react';
import { Typography } from '@hmsexp/component-library';
import get from 'lodash/get';
import { View } from '../../../../../../components/Common/react-native-components';
import EmojiMap from '../../../../../../components/Common/EmojiMap';
import HighchartsReactTooltip from './HighchartsReactTooltip';
import MultiFeatureCard from '../../../../../../components/Common/Card/MultiOptionsCard/MultiFeatureCard';
import { makeJsonFromMetricData } from '../../../../../../utils/transformChartsAndTableData';
import { useTransformSentimentChartData } from './useTransformSentimentChartData';

const SentimentChart = forwardRef(({ item, timeperiodLabel }, ref) => {
  const chartRef = useRef(null);
  const data = get(item, 'cstDataV2', []);

  const actionButtonClick = e => {
    handleHighChartsExport(e, chartRef, item);
  };

  useImperativeHandle(ref, () => ({ actionButtonClick }));

  let dd = makeJsonFromMetricData(data);

  const [hoveredPoint, setHoveredPoint] = useState(null);

  let { options } = useTransformSentimentChartData(dd, setHoveredPoint);

  const renderContent = (_, contentRef) => {
    return (
      <View style={{ flexDirection: 'row' }}>
        <View
          style={{
            width: 60,
            borderRightWidth: 1,
            paddingVertical: 20,
            borderColor: 'rgb(206, 212, 218)',
            justifyContent: 'space-between',
            alignItems: 'center'
          }}>
          <EmojiMap type='HAPPY' />
          <EmojiMap type='SAD' />
        </View>
        <View style={{ flex: 1 }}>
          <HighchartsReact ref={chartRef} highcharts={Highcharts} options={options} />
          {chartRef.current?.chart && (
            <HighchartsReactTooltip hoveredPoint={hoveredPoint} chart={chartRef.current.chart} />
          )}
        </View>
      </View>
    );
  };

  return (
    <MultiFeatureCard
      title={item?.title}
      subTitle={timeperiodLabel}
      style={{ childContainer: { paddingVertical: 20 } }}
      enableActionBtn={get(item, 'enableActionBtn', false)}
      enableSwitchTab={get(item, 'enableSwitchTab', false)}
      switchOptions={get(item, 'switchOptions', [])}
      renderContent={renderContent}
      renderFooter={() => (
        <Typography fontWeightType='regular' variant='button'>
          {item?.footerText}
        </Typography>
      )}
    />
  );
});

export default SentimentChart;
